import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as irSearchActions from '../../../redux/actions/irSearchActions';
import LoadingBar from '../../common/LoadingBar';
import PopupError from '../../common/PopupErrorComponent/PopupError';
import FilterTable from '../../common/FilterTable';
import UpdateFromPacer from '../../common/UpdateFromPacer';


class CaseSummary extends Component {

    componentDidMount() {
        if (this.props.purchase_right_away)
            this.purchaseSummaryData();
        else
            this.getSummaryData();
    }

    getSummaryData = () => {
        this.props.dispatch(irSearchActions.getCaseData({
            type: 'case_summary',
            case_uuid: this.props.case_uuid,
        }));
    }

    purchaseSummaryData = () => {
        this.props.dispatch(irSearchActions.purchaseCaseData({
            type: 'case_summary',
            case_uuid: this.props.case_uuid,
            purchase_right_away: this.props.purchase_right_away,
        }));
    }

    render() {
        if (!this.props.dataReady) return <LoadingBar/>;

        const SummaryData = this.props.summary || [];

        return (
            <div className="ir-search-query case-summary">
                <PopupError errors={this.props.error} />
                <FilterTable>
                    {!!SummaryData.length ? (
                        <div dangerouslySetInnerHTML={{__html: SummaryData}}/>
                    ) : (
                        <div
                            className="ir-search-status-message messages warning"
                        >There Are No Summary Data For This Case</div>
                    )}
                </FilterTable>
                <UpdateFromPacer
                    pacerUpdateHandler={ this.purchaseSummaryData }
                    pacerReceipt={this.props.receipt}
                    lastUpdated={this.props.lastUpdated}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const irSearch = state.get('irSearch').toJS();
    const validationErrors = state.get('validationErrors') ? state.get('validationErrors').toJS() : null;
    return {
        dataReady: irSearch.data_ready,
        summary: irSearch.data,
        receipt: irSearch.receipt,
        lastUpdated: irSearch.lastUpdated,
        error: irSearch.error,
        clientCodeValidation: validationErrors,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseSummary);


// WEBPACK FOOTER //
// ./src/components/case/summary/CaseSummary.js